import { EditorOptions } from '@tiptap/core';
import { Editor } from '@tiptap/react';

import { DependencyList, useEffect, useState } from 'react';

function useForceUpdate() {
  const [, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

// hack to get around https://github.com/ueberdosis/tiptap/issues/2182
// when useEditor is returned as null, the height of the editor is 0 which causes
// virtuoso to get the incorrect height.
// original gist: https://gist.github.com/ryanto/4a431d822a98770c4ca7905d9b7b07da
export const useEditor = (
  options: Partial<EditorOptions> = {},
  deps: DependencyList = []
) => {
  const [editor, setEditor] = useState<Editor>(() => new Editor(options));
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    let instance: Editor;

    if (editor.isDestroyed) {
      instance = new Editor(options);
      setEditor(instance);
    } else {
      instance = editor;
    }

    instance.on('transaction', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          forceUpdate();
        });
      });
    });

    return () => {
      instance.destroy();
    };
  }, deps);

  return editor;
};
